module.exports = __webpack_public_path__ + "img/art-42.b1a74d85.png";